class SignupPageController {
}

const signupPageComponentDefinition = {
    controller: SignupPageController,
    template: require('./signup-page.component.html').trim(),
};

module.exports = {
    SignupPageController,
    signupPageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/signup/signup-page.component.js